module.exports = __webpack_public_path__ + "img/Assembling_1200x800.967a5e20.png";